export default __webpack_public_path__ + "static/media/blood-glucose-black.c8173ac8.svg";